import { useState, useEffect, useCallback } from "react";
import { getPreferences, updatePreferences } from "@/lib/api";

/**
 * Per-user UI preferences stored server-side, so layouts follow the user
 * across devices. setPref updates optimistically and persists in the
 * background; a failed save just keeps the local value for the session.
 */
export function usePreferences() {
  const [prefs, setPrefs] = useState({});
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    let alive = true;
    getPreferences()
      .then(res => { if (alive) setPrefs(res.data || {}); })
      .catch(() => {})
      .finally(() => { if (alive) setLoaded(true); });
    return () => { alive = false; };
  }, []);

  const setPref = useCallback((key, value) => {
    setPrefs(prev => ({ ...prev, [key]: value }));
    updatePreferences({ [key]: value }).catch(() => {});
  }, []);

  return { prefs, setPref, loaded };
}
